"use client";
import WorkCard from "@/components/landing/desktop/works/WorkCard";
import { buttonVariants } from "@/components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi
} from "@/components/ui/carousel";
import { useGetRecentWorks } from "@/lib/hooks/admin-dashboard/recent-works/get/useGetRecentWorks";
import { cn } from "@/lib/utils";
import Link from "next/link";
import React from "react";

const isEven = (value: number) => value % 2 === 0;

const RecentWorks = ({ publicArea }: { publicArea?: boolean }) => {
  const { data, isLoading, isError } = useGetRecentWorks();
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);

  // Auto slide logic
  React.useEffect(() => {
    if (!api) return;

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });

    const interval = setInterval(() => {
      const currentIndex = api.selectedScrollSnap();
      const lastIndex = api.scrollSnapList().length - 1;

      if (currentIndex === lastIndex) {
        api.scrollTo(0); // Go back to start
      } else {
        api.scrollNext(); // Go to next
      }
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, [api]);

  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error</p>;

  const works = data as Work[];

  return (
    <main>
      {!publicArea && (
        <section className="flex justify-between items-center mb-10">
          <h1 className="text-2xl font-semibold">Control Recent Work Section</h1>
          <Link area-label={"Create Work"} href="/blog-dashboard/recent-works/create" className={buttonVariants()}>
            Create Work
          </Link>
        </section>
      )}

      {/* Desktop */}
      <div className="hidden sm:flex gap-10 2xl:gap-20">
        {works.map((work, index) => (
          <div
            key={index}
            className={cn("flex h-[24rem]", isEven(index) ? "items-start" : "items-end")}
          >
            <WorkCard work={work} />
          </div>
        ))}
      </div>

      {/* Mobile Carousel */}
      <div className="w-[95vw] sm:hidden">
        <div className="mx-auto max-w-sm">
          <Carousel setApi={setApi} className="w-full max-w-sm">
            <CarouselContent>
              {works.map((work, index) => (
                <CarouselItem key={index}>
                  <WorkCard work={work} />
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </main>
  );
};

export default RecentWorks;
